<template>
  <AppLayout class="talentpools" centered customToolbar>
    <template v-slot:body>
      <div class="worker-details container col-lg-10 col-sm-12">
        <BackBar parent="/candidates" title="People" />
        <BaseListToolbar title="Talent Pools" hideSearchBar />
        <div v-if="isFetchingTalentPools">
          <v-skeleton-loader v-for="i in 10" :key="i" type="list-item-avatar" />
        </div>
        <div v-else>
          <v-list-item
            @click="() => viewTalentPool(talentPool)"
            v-for="talentPool in talentPools"
            :key="talentPool.id"
          >
            <TalentPoolListItem
              :talentPool="talentPool"
              data-test="talent-pool"
            />
          </v-list-item>
        </div>
        <BaseFooter>
          <ExpandedButtons>
            <Permissioned
              :vertical="isMobile"
              section="talent-pools"
              class="actions-bar"
            >
              <NewTalentPoolAction
                permission="create"
                data-test="new-talent-pool"
              />
            </Permissioned>
          </ExpandedButtons>
        </BaseFooter>
      </div>
    </template>
  </AppLayout>
</template>

<script>
import AppLayout from "@/components/common/base-layouts/AppLayout";
import BackBar from "@/components/common/base-layouts/BackBar";
import TalentPoolListItem from "@/views/workers/TalentPools/components/TalentPoolListItem";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";
import { createNamespacedHelpers } from "vuex";
import { TALENT_POOLS_NAMESPACE } from "@/store/modules/talentPools";
import { FETCH_TALENT_POOLS } from "@/store/modules/talentPools/actions";
import NewTalentPoolAction from "@/views/workers/TalentPools/actions/NewTalentPoolAction";
import BaseFooter from "@/components/common/BaseFooter";
import ExpandedButtons from "@/components/common/ExpandedButtons";
import Permissioned from "@/components/common/Permissioned";

const { mapActions, mapState } = createNamespacedHelpers(
  TALENT_POOLS_NAMESPACE
);

export default {
  name: "TalentPools",
  components: {
    AppLayout,
    BackBar,
    TalentPoolListItem,
    BaseListToolbar,
    NewTalentPoolAction,
    BaseFooter,
    ExpandedButtons,
    Permissioned
  },
  created() {
    this.fetchTalentPools();
  },
  computed: {
    ...mapState({
      talentPools: state => state.talentPools,
      isFetchingTalentPools: state => state.isFetchingTalentPools
    })
  },
  methods: {
    ...mapActions({
      fetchTalentPools: FETCH_TALENT_POOLS
    }),
    viewTalentPool({ id }) {
      this.$router.push({ name: "talentPoolPeople", params: { id } });
    }
  }
};
</script>

<style lang="scss">
.talentpools {
  .list-item .v-avatar.v-list-item__avatar {
    background-color: #c727ff30;
    align-self: flex-start;
  }
}
</style>
